import { useContext } from 'react';
import AuthContext from "../context/AuthContext";
import { InsertWishlist, RemoveWishlist } from "../api/wishlistService";

const useWishlistHandler = () => {
    const { user } = useContext(AuthContext);

    const HandleWishListInsert = async ({ Style_ID, JewelCode, StyleNo, Quantity, fetchData }) => {
        if (!user?.SelectedCustomer_ID || user?.SelectedCustomer_ID === 0) {
            return {
                success: false,
                message: "Please select a specific customer to add items to Wishlist.",
                type: "warning"
            };
        }
        const requestParameter = {
            Party_ID: user?.SelectedCustomer_ID || "0",
            Style_ID: Style_ID,
            JewelCode: JewelCode,
            StyleNo: StyleNo,
            Quantity: Quantity,
        };
        
        if (!user?.isAuthenticated) {
            return {
                success: false,
                message: "Please log in to add items to your Wishlist.",
                type: "warning"
            };
        }

        try {
            const wishListData = await InsertWishlist(requestParameter);
            if (wishListData && wishListData.Message && Array.isArray(wishListData.Message) && wishListData.Message.length > 0) {
                let newBasketID = "";
                const lastIndex = (wishListData.InsertWishlist?.length || 0) - 1;
                if (lastIndex >= 0) {
                    newBasketID = wishListData.InsertWishlist[lastIndex]?.Basket_ID;
                }
                
                const returnCode = wishListData.Message[0]?.RETURNCODE;
                const returnMessage = wishListData.Message[0]?.RETURNMESSAGE || "Item Added To Wishlist!";
                const returnMessageTitle = wishListData.Message[0]?.RETURNMESSAGETITLE || "Successful!";
                
                switch (returnCode) {
                    case "1":
                        if (typeof fetchData === "function") fetchData();
                        return {
                            success: true,
                            message: returnMessage,
                            titleMessage: returnMessageTitle,
                            newBasketID: newBasketID,
                        };
                    case "0":
                        return {
                            success: false,
                            message: returnMessage,
                            type: "warning",
                        };
                    case "-1":
                        return {
                            success: false,
                            message: returnMessage,
                            type: "error",
                        };
                    default:
                        return {
                            success: false,
                            message: "Something Went Wrong. Please try again later.",
                        };
                }
            } else {
                return {
                    success: false,
                    message: "Failed to add item to Wishlist. Response is empty or invalid.",
                };
            }
        } catch (error) {
            return {
                success: false,
                message: `An error occurred while adding the item: ${error.message || error}`,
            };
        }
    };

    const HandleWishListRemove = async ({
        Basket_ID,
        BasketType,
        Quantity,
        Rate,
        Cart_ID,
        Style_ID,
        fetchData,
        Wishlist_ID,
    }) => {
        const requestParameter = {
            Party_ID: user?.SelectedCustomer_ID || "0",
            Cart_ID: Cart_ID,
            Style_ID: Style_ID,
        };
        
        try {
            const wishListData = await RemoveWishlist(requestParameter);
            if (wishListData && wishListData.Message && Array.isArray(wishListData.Message) && wishListData.Message.length > 0) {
                const returnCode = wishListData.Message[0]?.RETURNCODE;
                const returnMessage = wishListData.Message[0]?.RETURNMESSAGE || "Item Removed From Wishlist!";
                const returnMessageTitle = wishListData.Message[0]?.RETURNMESSAGETITLE || "Successful!";
                
                switch (returnCode) {
                    case "1":
                        if (fetchData) fetchData();
                        return {
                            success: true,
                            message: returnMessage,
                            titleMessage: returnMessageTitle,
                        };
                    case "0":
                        return {
                            success: false,
                            message: returnMessage,
                            type: "warning",
                        };
                    case "-1":
                        return {
                            success: false,
                            message: returnMessage,
                            type: "error",
                        };
                    default:
                        return {
                            success: false,
                            message: "Something Went Wrong. Please try again later.",
                        };
                }
            } else {
                return {
                    success: false,
                    message: "Failed to remove from Wishlist. Response is empty or invalid.",
                };
            }
        } catch (error) {
            return {
                success: false,
                message: `An error occurred while removing the item: ${error.message || error}`,
            };
        }
    };
    
    return { HandleWishListInsert, HandleWishListRemove }
};

export default useWishlistHandler;
